import * as React from "react";
import * as PropTypes from "prop-types";
import Upload from "./Upload.jsx";
import { fromBase64, getFileExt, parseBase64 } from "./fileUpload";
import PdfViewer from "./PdfViewer";
import Iframe from "react-iframe";
// import ReactFileViewer from "react-file-viewer";
import API from "../../api/api/API.js";
// import DocViewer, { DocViewerRenderers } from "react-doc-viewer";

const FileViewer = React.forwardRef(function FileViewer(props, ref) {
  const upload = React.useRef();
  const { browser, acceptTypes, onMount, onChange, multiple } = props;
  const [file, setFile] = React.useState(props.file ?? null);
  const [type, setType] = React.useState(props.type ?? null);
  const [text, setText] = React.useState("");

  React.useEffect(() => setFile(props.file ?? null), [props.file]);
  React.useEffect(() => setType(props.type ?? null), [props.type]);
  React.useEffect(() => {
    if (type === "txt") {
      async function fetchTextData() {
        try {
          const response = await fetch(file);
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          const data = await response.text();
          setText(data);
        } catch (error) {
          console.error('Fetch error:', error);
        }
      }

      fetchTextData();
    }
  }, [file, type]);

  const handleBase64 = async (url) => {
    const api = new API();

    const base64 = await api({
      cmd: "getFileFromUrl",
      payload: { url: url, type: "pdf" },
    });

    setFile(base64);
  };

  function handleClose() {
    console.log(">> X");
    upload.current.unmount();
    setFile(null);
    onChange?.(null);
  }

  function handleChange(files) {
    if (!files && browser) {
      onChange?.(null);
      return setFile(null);
    }
    const files_ = files.map((file) => ({
      ...file,
      data: `data:${file.type};base64,${file.data}`,
    }));
    setFile(files_);
    setType(getFileExt(files[0].name));
    onMount?.(multiple ? files : files[0]);
    onChange?.(multiple ? files : files[0]);
  }

  React.useImperativeHandle(
    ref,
    () => {
      return {
        unmount() {
          if (!browser) return;
          handleClose();
        },
      };
    },
    []
  );

  return (
    <>
      <Upload
        style={{ display: browser && !file ? "flex" : "none" }}
        ref={upload}
        acceptTypes={acceptTypes}
        onChange={handleChange}
        multiple={multiple}
        onProgress={(e) => console.log(e)}
      />
      {file && ui(file, type, { handleClose }, props.url, text)}
    </>
  );
});

function ui(file, type, actions, url, text) {
  // console.log(type,url);
  if(url === ""){
  //   console.log("url is empty");
    switch (type) {
      case "pdf": {
        if (url !=="" && file?.startsWith("http")){
          return (
            <PdfViewer url={file} mode="light" />
          );
        }
          return <PdfViewer url={file[0].data} name={file[0].name} onClose={actions.handleClose} />;
      }
      case "txt": {
        const value_ = fromBase64(parseBase64(file[0].data));
        return (
          <textarea
            // readOnly={readOnly}
            id="txt-viewer--cont"
            style={{
              width: "100%",
              height: "100%",
              padding: 62,
              outline: "none",
              border: "none",
              resize: "none",
              fontSize: "1.26rem",
              background: "#fff",
              color: "#000",
            }}
            value={value_}
            // onChange={!readOnly ? null : props.onChange}
            onClose={actions.handleClose}
          />
        );
      }
      case "docx": {
        // console.log(file, url);
        if (url !== "" && file?.startsWith("http")) {
          return (
            <Iframe
              src={`https://view.officeapps.live.com/op/embed.aspx?src=${file}`}
              display="block"
              // position="relative"
              height="100%"
              width="100%"
              frameBorder={"0"}
            />
          );
        }
        return (
          <div style={{ overflow: "hidden", height: "100vh", width: "100%", display: "flex", flexDirection: "column" }}>
            <div style={{ flex: 1, overflow: "auto" }}>
              {/* <ReactFileViewer
                key={file[0].id || 0}
                style={{ height: "100%", width: "100%" }}
                fileType="docx"
                filePath={file[0].data}
              /> */}
            </div>
          </div>
        );
      }
      case "pptx": {
        // console.log(file, url);
        if (url !== "" && file?.startsWith("http")) {
          return (
            <Iframe
              src={`https://view.officeapps.live.com/op/embed.aspx?src=${file}`}
              display="block"
              // position="relative"
              height="100%"
              width="100%"
              frameBorder={"0"}
            />
          );
        }
        return (
          <div >
            {/* style={{ ...props.style }} */}
            {/* <ReactFileViewer key={file[0].id || 0} fileType={"pptx"} filePath={file[0].data} /> */}
          </div>
        );
      }
      case "png":
      case "jpeg":
      case "jpg": {
        // console.log(file)
        if (url !== "" && file?.startsWith("http")) {
          return (
            <div style={{ overflowY: 'auto', maxHeight: '400px' }}>
              <img style={{ width: '90%' }} src={file} alt="" />
            </div>
          );
        }
        return (
          <div className="flex flex-col h-full items-center gap-4 overflow-auto bg-[#ededed] p-2">
            {file.map((d) => (
              <img key={d.id} className="w-[90%] bg-[#fff] shadow-[0_1px_6.5px_0_#224b9923]" src={d.data} alt="" />
            ))}
          </div>
        );
      }
      default:
        // console.log(file)
        return (
          <div >
            {/* style={{ ...props.style }} */}
            {/* <ReactFileViewer key={file[0].id || 0} style={{ overflow: "hidden" }} fileType={file[0].type} filePath={file[0].data} /> */}
          </div>
        );
    }
  } else {
    switch (type) {
      case "pdf": {
        if (url !== "" && file?.startsWith("http")) {
          return (
            <PdfViewer url={file} mode="light" />
          );
        }
        return <PdfViewer url={url} name={file[0].name} onClose={actions.handleClose} />;
      }
      case "txt": {
        // const readOnly = !!props.readOnly ?? true;
        const value_ = fromBase64(parseBase64(file));
        return (
          <textarea
            // readOnly={readOnly}
            id="txt-viewer--cont"
            style={{
              width: "100%",
              height: "100%",
              padding: 62,
              outline: "none",
              border: "none",
              resize: "none",
              fontSize: "1.26rem",
              background: "#fff",
              color: "#000",
            }}
            value={text}
            // onChange={!readOnly ? null : props.onChange}
            onClose={actions.handleClose}
          />
        );
      }
      case "docx": {
        // console.log(file, url);
        if (url !== "" && file?.startsWith("http")) {
          return (
            <Iframe
              src={`https://view.officeapps.live.com/op/embed.aspx?src=${file}`}
              display="block"
              // position="relative"
              height="100%"
              width="100%"
              frameBorder={"0"}
            />
          );
        }
        return (
          <div >
            {/* style={{ ...props.style }} */}
            {/* <ReactFileViewer key={file[0].id || 0} fileType={"docx"} filePath={file[0].data} /> */}
          </div>
        );
      }
      case "pptx": {
        // console.log(file, url);
        if (url !== "" && file?.startsWith("http")) {
          return (
            <Iframe
              src={`https://view.officeapps.live.com/op/embed.aspx?src=${file}`}
              display="block"
              // position="relative"
              height="100%"
              width="100%"
              frameBorder={"0"}
            />
          );
        }
        return null; // Return null or some placeholder if pptx is not handled
      }
      case "png":
      case "jpeg":
      case "jpg": {
        console.log(file)
        if (url !== "" && file?.startsWith("http")) {
          return (
            <div style={{ overflowY: 'auto', maxHeight: '1000px' }}>
              <img style={{ width: '90%' }} src={file} alt="" />
            </div>
          );
        }
        return (
          <div className="flex flex-col h-full items-center gap-4 overflow-auto bg-[#ededed] p-2">
            {file.map((d) => (
              <img key={d.id} className="w-[90%] bg-[#fff] shadow-[0_1px_6.5px_0_#224b9923]" src={d.data} alt="" />
            ))}
          </div>
        );
      }
      default:
        return (
          <div >
            {/* style={{ ...props.style }} */}
            {/* <ReactFileViewer key={file[0].id || 0} style={{ overflow: "hidden" }} fileType={file[0].type} filePath={file[0].data} /> */}
          </div>
        );
    }
  }
}

export default FileViewer;

FileViewer.propTypes = {
  browser: PropTypes.bool,
  acceptTypes: PropTypes.array,
  onMount: PropTypes.func,
  onChange: PropTypes.func,
  multiple: PropTypes.bool,
  file: PropTypes.array,
  type: PropTypes.string,
};
